module.exports = __webpack_public_path__ + "static/media/ChefAnilGrover.1a725175.png";